import { Action, Module, VuexModule } from "vuex-module-decorators";
import axios from "@/plugins/http";

import { API_ROUTES } from "@/utils/API";

@Module({ name: "MDocumentsV2", namespaced: true })
export default class MDocumentsV2 extends VuexModule {
  @Action
  async getFileNameContentDisposition(headerString: string) {
    if (!headerString) {
      console.log("content-disposition not found");

      return "";
    }

    const match = /filename=([^;]+)/.exec(headerString);

    if (match && match[1]) {
      const filename = match[1].trim();

      return filename;
    } else {
      console.log("Filename not found in content-disposition");

      return "";
    }
  }

  @Action
  async getFileData(fileId: number) {
    if (!fileId) return null;

    try {
      const url = await API_ROUTES.DOCUMENTS_FILE(fileId);

      const response = await axios.get<ArrayBuffer>(url, {
        responseType: "arraybuffer",
      });

      const { data } = response;

      if (!data) return;

      const contentDisposition = response.headers["content-disposition"];

      const link = await this.createFileLink(data);

      let name = await this.getFileNameContentDisposition(contentDisposition);

      if (!name) name = "archive";

      return { link, name };
    } catch {
      return null;
    }
  }

  @Action
  downloadFile({ link, name }: { link: string; name: string }) {
    const a = document.createElement("a");
    a.href = link;
    a.download = name;
    a.click();
    a.remove();
    URL.revokeObjectURL(link);
  }

  @Action
  createFileLink(binary: ArrayBuffer, type = "application/pdf") {
    const blob = new Blob([binary], { type });
    const link = URL.createObjectURL(blob);

    return link;
  }
}
